import {MdPlaylistRemove} from "react-icons/md";

const AddToTentativeButton = (props: any) => {
    return <MdPlaylistRemove/>
}
export default AddToTentativeButton